const runScriptOnReady = require('public/js/lib/run-script-on-ready');
const { isValidEmailFormat } = require('public/js/lib/email-validation');

function isReactOfferWaitlistActive() {
	if (typeof rp$ === 'undefined' || !rp$) {
		return false;
	}

	return rp$('.product-offer-module [data-waitlist-controlled="react"]').length > 0
		|| rp$('.product-offer-module[data-waitlist-controlled="react"]').length > 0;
}

function shouldDeferToReactWaitlist($target) {
	if (!isReactOfferWaitlistActive()) {
		return false;
	}

	return $target.closest('[data-waitlist-controlled="react"]').length > 0
		|| $target.closest('.product-purchase-module').length === 0;
}

function productSubscription() {
	if (typeof rp$ === 'undefined' || !rp$) {
		return;
	}

	if (isReactOfferWaitlistActive() && rp$('.product-purchase-module').length === 0) {
		return;
	}

	const $waitlistModal = rp$('#backorderWaitlistModal');
	const $waitlistSuccessModal = rp$('#backorderWaitlistSuccessModal');
	let defaultUserEmail = '';

	let lastSubmittedEmail = '';

	function getDefaultUserEmail() {
		if (defaultUserEmail !== '') {
			return defaultUserEmail;
		}

		const $input = rp$('#waitlist-email');
		if ($input?.length > 0) {
			const emailInput = $input[0];
			const fromDom = String(
				emailInput?.defaultValue ?? $input.attr('value') ?? $input.val() ?? '',
			).trim();
			if (fromDom !== '') {
				defaultUserEmail = fromDom;
			}
		}

		return defaultUserEmail;
	}

	function updateLabelState() {
		const $input = rp$('#waitlist-email');
		if ($input?.length > 0) {
			const value = String($input.val() ?? '').trim();
			if (value) {
				$input.addClass('has-value');
			} else {
				$input.removeClass('has-value');
			}
		}
	}

	function restoreDefaultUserEmail() {
		const $input = rp$('#waitlist-email');
		const emailToRestore = getDefaultUserEmail();
		if ($input?.length > 0 && emailToRestore !== '') {
			$input.val(emailToRestore);
		}
		updateLabelState();
	}

	function closeWaitlistModal() {
		const $waitlistForm = rp$('#backorder-waitlist-form');
		if ($waitlistForm.length) {
			$waitlistForm[0].reset();
			$waitlistForm.removeClass('has-error');
		}

		restoreDefaultUserEmail();

		const $messageDiv = rp$('#waitlist-message');
		if ($messageDiv.length) {
			$messageDiv.hide().removeClass('error success').text('');
		}

		rp$('#waitlist-submit-btn')
			.prop('disabled', false)
			.removeClass('loading');

		lastSubmittedEmail = '';
	}
	
	function setModalBackground($modal) {
		if ($modal?.length > 0) {
			const $modalContent = $modal.find('.modal-content');
			if ($modalContent.length > 0) {
				$modalContent.css('background-color', '#fff');
			}
		}
	}
	
	setModalBackground($waitlistModal);
	setModalBackground($waitlistSuccessModal);

	rp$(document).on('click', '#backorder-waitlist-trigger', function () {
		const $trigger = rp$(this);
		if (shouldDeferToReactWaitlist($trigger)) {
			return;
		}

		restoreDefaultUserEmail();
		rp$('#waitlist-message').hide().removeClass('error success').text('');
		rp$('#backorder-waitlist-form').removeClass('has-error');

		// Re-enable the submit button when opening the modal
		rp$('#waitlist-submit-btn')
			.prop('disabled', false)
			.removeClass('loading');

		setTimeout(function() {
			const emailElement = document.getElementById('waitlist-email');
			if (emailElement) {
				emailElement.focus();
			}
		}, 600);
	});
	
	
	rp$(document).on('shown.bs.modal', '#backorderWaitlistModal', function () {
		updateLabelState();
		const $email = rp$('#waitlist-email');
		if ($email?.length > 0) {
			setTimeout(function() {
				const emailElement = $email[0];
				if (emailElement) {
					emailElement.focus();
				}
			}, 100);
		}
		const $modal = rp$(this);
		setModalBackground($modal);
		
		// Re-enable the submit button when modal is shown
		rp$('#waitlist-submit-btn')
			.prop('disabled', false)
			.removeClass('loading');
		
		const $closeButton = $modal.find('.waitlist-submit-button');
		const $modalTitle = $modal.find('.modal-title');
		if ($closeButton.length > 0 && $modalTitle.length > 0) {
			function applyTitleColor() {
				const buttonBgColor = window.getComputedStyle($closeButton[0]).backgroundColor;
				if (buttonBgColor && buttonBgColor !== 'rgba(0, 0, 0, 0)' && buttonBgColor !== 'transparent' && buttonBgColor !== 'rgb(0, 0, 0)') {
					const currentStyle = $modalTitle.attr('style') || '';
					const cleanedStyle = currentStyle.replace(/color\s*:[^;]+;?/gi, '');
					const newStyle = cleanedStyle + ' color: ' + buttonBgColor + ' !important;';
					$modalTitle.attr('style', newStyle);
				}
			}
			
			applyTitleColor();
			setTimeout(applyTitleColor, 5);
			setTimeout(applyTitleColor, 50);
			setTimeout(applyTitleColor, 200);
			setTimeout(applyTitleColor, 500);
		}
	});
	
	
	if (typeof $ !== 'undefined' && $ !== rp$) {
		$(document).on('shown.bs.modal', '#backorderWaitlistModal', function() {
			const emailElement = document.getElementById('waitlist-email');
			if (emailElement) {
				setTimeout(function() {
					emailElement.focus();
				}, 100);
			}
		});
	}

	rp$(document).on('hidden.bs.modal', '#backorderWaitlistModal', closeWaitlistModal);

	rp$(document).on('input change', '#waitlist-email', function () {
		const $input = rp$(this);
		if (shouldDeferToReactWaitlist($input)) {
			return;
		}

		updateLabelState();
		const currentEmail = String($input.val() ?? '').trim();
		const $messageDiv = rp$('#waitlist-message');
		const $waitlistForm = rp$('#backorder-waitlist-form');
		if (currentEmail !== lastSubmittedEmail && $messageDiv.hasClass('error')) {
			$messageDiv.hide().removeClass('error').text('');
			$waitlistForm.removeClass('has-error');
		}
	});

	rp$(document).on('focus blur', '#waitlist-email', function () {
		if (shouldDeferToReactWaitlist(rp$(this))) {
			return;
		}

		updateLabelState();
	});
	

	rp$(document).on('shown.bs.modal', '#backorderWaitlistSuccessModal', function () {
		const $modal = rp$(this);
		setModalBackground($modal);
		
		const $closeButton = $modal.find('.waitlist-submit-button');
		const $modalTitle = $modal.find('.modal-title');
		if ($closeButton.length > 0 && $modalTitle.length > 0) {
			function applyTitleColor() {
				const buttonBgColor = window.getComputedStyle($closeButton[0]).backgroundColor;
				if (buttonBgColor && buttonBgColor !== 'rgba(0, 0, 0, 0)' && buttonBgColor !== 'transparent' && buttonBgColor !== 'rgb(0, 0, 0)') {
					const currentStyle = $modalTitle.attr('style') || '';
					const cleanedStyle = currentStyle.replace(/color\s*:[^;]+;?/gi, '');
					const newStyle = cleanedStyle + ' color: ' + buttonBgColor + ' !important;';
					$modalTitle.attr('style', newStyle);
				}
			}
			
			applyTitleColor();
			setTimeout(applyTitleColor, 5);
			setTimeout(applyTitleColor, 50);
			setTimeout(applyTitleColor, 200);
			setTimeout(applyTitleColor, 500);
		}
	});

	
	rp$(document).on('click', '#waitlist-submit-btn', function(e) {
		e.preventDefault();
		e.stopPropagation();

		const $submitBtn = rp$(this);
		if (shouldDeferToReactWaitlist($submitBtn)) {
			return false;
		}
		
		const $waitlistModal = rp$('#backorderWaitlistModal');
		const $waitlistSuccessModal = rp$('#backorderWaitlistSuccessModal');
		const $waitlistForm = rp$('#backorder-waitlist-form');
		const $messageDiv = rp$('#waitlist-message');
		
		$submitBtn.prop('disabled', true).addClass('loading');
		
		const email = String(rp$('#waitlist-email').val() ?? '').trim();
		const $productModule = rp$('.product-purchase-module').length > 0
			? rp$('.product-purchase-module')
			: rp$('.product-offer-module');
		const data = {
			mpn_stripped: $productModule.attr('data-sku-stripped') || '',
			brand_key: $productModule.attr('data-catalog') || '',
			email: email,
		};

		if (email !== lastSubmittedEmail) {
			$messageDiv.hide().removeClass('error').text('');
		}

		if (!data.email) {
			$waitlistForm.addClass('has-error');
			$messageDiv.addClass('error').text('Please enter your email address').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			lastSubmittedEmail = '';
			return false;
		}

		if (!isValidEmailFormat(data.email)) {
			$waitlistForm.addClass('has-error');
			$messageDiv.addClass('error').text('Please enter a valid email address').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			lastSubmittedEmail = '';
			return false;
		}

		lastSubmittedEmail = email;

		const ajaxFn = (typeof $ajax !== 'undefined' ? $ajax : null) ?? rp$?.ajax ?? null;

		if (!ajaxFn) {
			console.error('Product Subscription: AJAX function not available');
			$waitlistForm.addClass('has-error');
			$messageDiv.addClass('error').text('An error occurred. Please try again later.').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			return false;
		}

		ajaxFn({
			type: 'POST',
			url: '/ajax/backorder-waitlist/subscribe',
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: function(response) {
				if (response?.status === 'ok') {
					$submitBtn.prop('disabled', false).removeClass('loading');
					
					function showSuccessModal() {
						if ($waitlistSuccessModal?.length > 0) {
							setModalBackground($waitlistSuccessModal);
							$waitlistSuccessModal.modal('show');
						}
					}
					
					if ($waitlistModal?.length > 0) {
						const isModalShown = $waitlistModal.hasClass('show') || $waitlistModal.is(':visible') || $waitlistModal.hasClass('in');
						
						if (isModalShown) {
							let successModalShown = false;
							
							$waitlistModal.one('hidden.bs.modal', function() {
								if (!successModalShown) {
									successModalShown = true;
									showSuccessModal();
								}
							});
							
							setTimeout(function() {
								if (!successModalShown) {
									successModalShown = true;
									showSuccessModal();
								}
							}, 500);
							
							$waitlistModal.modal('hide');
						} else {
							showSuccessModal();
						}
					} else {
						showSuccessModal();
					}
				} else {
					const message = response?.message ?? '';
					if (message) {
						$waitlistForm.addClass('has-error');
						$messageDiv.addClass('error').text(message).show();
					}
					$submitBtn.prop('disabled', false).removeClass('loading');
				}
			},
			error: function(xhr) {
				let errorMessage = '';
				try {
					const response = JSON.parse(xhr.responseText);
					errorMessage = response?.message ?? '';
				} catch (e) {
				}
				if (errorMessage) {
					$waitlistForm.addClass('has-error');
					$messageDiv.addClass('error').text(errorMessage).show();
				}
				$submitBtn.prop('disabled', false).removeClass('loading');
			}
		});

		return false;
	});
	
	rp$(document).on('submit', '#backorder-waitlist-form', function(e) {
		e.preventDefault();
		e.stopPropagation();

		return false;
	});
}

rp$.fn.product_subscription = productSubscription;

runScriptOnReady('product_subscription', productSubscription);
